import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import { CONTACT, DISHES, IMAGES } from "@/data/site";
import { Reveal, Kicker } from "./Reveal";
import { TikTokIcon } from "./TikTokIcon";

const FEED = [IMAGES.spread, ...DISHES.map((d) => d.img)].slice(0, 6);

export default function Social() {
  const { t } = useLang();
  return (
    <section className="relative bg-[var(--bg-2)] py-24 md:py-32" data-testid="social-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="flex flex-col items-start gap-8 md:flex-row md:items-end md:justify-between">
          <div>
            <Kicker className="mb-5">{t.socialKicker}</Kicker>
            <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-[var(--text)] md:text-7xl">
              {t.socialTitle}
            </h2>
            <p className="mt-5 max-w-md font-sans text-[15px] leading-relaxed text-[var(--text-2)]">
              {t.socialIntro}
            </p>
          </div>
          <Reveal delay={0.1}>
            <a
              href={CONTACT.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="tiktok-follow-btn"
              className="inline-flex items-center gap-3 border border-[var(--gold)]/50 px-7 py-4 font-sans text-sm tracking-wide text-[var(--gold)] transition-colors hover:bg-[var(--gold)]/10"
            >
              <TikTokIcon size={18} /> {CONTACT.tiktokHandle}
            </a>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-6">
          {FEED.map((src, i) => (
            <motion.a
              key={i}
              href={CONTACT.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group relative aspect-square overflow-hidden"
              data-testid={`tiktok-tile-${i}`}
            >
              <img
                src={src}
                alt=""
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/60 opacity-0 transition-opacity group-hover:opacity-100">
                <TikTokIcon size={22} className="text-[var(--gold)]" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
